import { useState } from 'react';

export default function NewsletterSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email) {
      setSubmitMessage('Please fill in all fields');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);

      const response = await fetch('https://readdy.ai/api/form/d6b2rinmvg9ih2c7av7g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Thank you for subscribing! You\'ll receive our best flight deals.');
        setFormData({ name: '', email: '' });
      } else {
        setSubmitMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#14B8A6] to-[#0F9688]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="ri-mail-line text-white text-3xl"></i>
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
          Get Airline Offers & Fare Alerts
        </h2>
        <p className="text-xl text-white/90 mb-8">
          Subscribe to receive exclusive flight deals, fare alerts, and travel tips directly to your inbox
        </p>
        <p className="text-sm text-white/80 mb-8">No spam. Only genuine flight deals.</p>

        <form onSubmit={handleSubmit} data-readdy-form className="max-w-2xl mx-auto">
          <input type="hidden" name="form-id" value="flight-newsletter" />
          
          <div className="bg-white rounded-2xl p-6 shadow-2xl">
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-lg focus:border-[#14B8A6] focus:outline-none text-sm transition-colors"
                required
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                className="w-full px-6 py-4 border-2 border-gray-200 rounded-lg focus:border-[#14B8A6] focus:outline-none text-sm transition-colors"
                required
              />
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-[#14B8A6] text-white py-4 rounded-lg font-semibold text-lg hover:bg-[#0F9688] transition-colors shadow-lg disabled:opacity-50 cursor-pointer whitespace-nowrap"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe for Deals'}
            </button>

            {submitMessage && (
              <p className={`text-sm mt-4 ${submitMessage.includes('Thank you') ? 'text-green-600' : 'text-red-600'}`}>
                {submitMessage}
              </p>
            )}
          </div>
        </form>

        <div className="mt-12 flex flex-wrap justify-center gap-8 text-white/90">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl"></i>
            <span className="text-sm">Weekly Fare Alerts</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl"></i>
            <span className="text-sm">Exclusive Deals</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl"></i>
            <span className="text-sm">Travel Tips</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl"></i>
            <span className="text-sm">Unsubscribe Anytime</span>
          </div>
        </div>
      </div>
    </section>
  );
}
